import React, { useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  
  // Get current language, normalizing to just 'en' or 'es'
  const getCurrentLang = () => {
    const lang = i18n.language || 'en';
    return lang.startsWith('es') ? 'es' : 'en';
  };
  
  const [currentLang, setCurrentLang] = useState(getCurrentLang);

  const toggleLanguage = useCallback(() => {
    const newLanguage = currentLang === "en" ? "es" : "en";
    
    // Update local state immediately for instant UI feedback
    setCurrentLang(newLanguage);
    
    // Save to localStorage immediately
    try {
      localStorage.setItem('i18nextLng', newLanguage);
    } catch (e) {}
    
    // Change i18n language
    i18n.changeLanguage(newLanguage);
  }, [currentLang, i18n]);

  return (
    <button
      onClick={toggleLanguage}
      className="inline-flex items-center gap-1.5 px-2 py-1.5 rounded-lg border border-grey-300 bg-white hover:bg-grey-50 text-xs font-medium text-grey-700 dark:bg-grey-800 dark:border-grey-600 dark:text-grey-200 dark:hover:bg-grey-700 transition-colors"
      title="Toggle language / Cambiar idioma"
    >
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
      </svg>
      <span>{currentLang === "en" ? "ES" : "EN"}</span>
    </button>
  );
};

export default LanguageSwitcher;
